/**
 * Prepare data
 * @param {!string} columnsString
 * @param {!Object} row
 * @return {!Object}
 */
export const prepareDataForPostReq = (columnsString, row) => {
    const columns = columnsString.split(', ');
    return columns.reduce((o, key) => ({...o, [key]: row[key]}), {});
};

/**
 * Extract columns and values for inserting
 * @param {!Object} updatedRow
 * @return {!Array}
 */
export const extractColumnsAndValuesForInserting = (updatedRow) => {
    const columns = [];
    const values = [];
    for (const k in updatedRow) {
        if (k !== 'idx' && updatedRow.hasOwnProperty(k)) {
            columns.push(k);
            if (updatedRow[k] === undefined) {
                updatedRow[k] = '';
            }
            if (typeof updatedRow[k] === 'string') {
                values.push(`'${updatedRow[k]}'`); // string should be wrapped into quotes
            } else {
                values.push(updatedRow[k]);
            }
        }
    }
    return [columns, values];
};

/**
 * Convert row data into values string for updating row in the table
 * @param {!Object} row
 * @return {!string}
 */
export const convertValuesForUpdatingRow = (row) => {
    let str = '';
    for (const k in row) {
        if (row.hasOwnProperty(k)) {
            if (typeof row[k] === 'string') {
                str += `${k} = '${row[k]}', `; // string should be wrapped into quotes
            } else {
                str += `${k} = ${row[k]}, `;
            }
        }
    }
    return str;
};

/**
 * Convert row data into values string for updating row in the table
 * @param {!Object} row
 * @return {!string}
 */
export const buildIdAndAddToList = (primaryKeysColumn, list) => {
    return list.map((item) => {
        delete item.total;
        const r = [];
        for (const k in item) {
            if (primaryKeysColumn.includes(k)) {
                r.push(item[k]);
            }
        }
        item.id = r.join('-');
        return item;
    });
};


export const buildWhereConditionsWithKeysAndValues = (primaryKeysColumn, updatedRow) => {
    let result = '';
    primaryKeysColumn.forEach((col, index) => {
        if (updatedRow.hasOwnProperty(col)) {
            let target = '';
            if (typeof updatedRow[col] === 'string') {
                target = `'${updatedRow[col]}'`;
            } else {
                target = `${updatedRow[col]}`;
            }
            if (index === primaryKeysColumn.length - 1) {
                result += `${col} = ${target}`;
            } else {
                result += `${col} = ${target} and `;
            }
        }
    });
    return result;
};

export const parseError = (error) => {
    let readableErrorMessage = '';
    const errorMessage = error.message || JSON.stringify(error);

    if (errorMessage.includes('duplicate key value violates unique constraint')) {
        readableErrorMessage = 'This record already exists and cannot be duplicated. Please check your data for any duplicates.';
    } else if (errorMessage.includes('violates not-null constraint')) {
        readableErrorMessage = 'Missing required fields. Please make sure all required fields are filled.';
    } else if (errorMessage.includes('violates check constraint')) {
        readableErrorMessage = 'One or more fields contain invalid data according to the rules set for them. Please correct your data and try again.';
    } else if (errorMessage.includes('invalid input syntax for type numeric')) {
        readableErrorMessage = 'Please enter a valid number. Fields that require numbers cannot be left empty or filled with text.';
    } else if (errorMessage.includes('invalid input syntax for type')) {
        readableErrorMessage = 'Invalid data type provided. Please check the data types of provided values and correct them.';
    } else if (errorMessage.includes('value too long for type')) {
        readableErrorMessage = 'Some fields contain too much text. Please reduce the text to fit the allowed length and try again.';
    } else if (errorMessage.includes('permission denied')) {
        readableErrorMessage = 'You do not have the necessary permissions to perform this operation. Please contact your administrator.';
    } else if (errorMessage.includes('could not connect to server')) {
        readableErrorMessage = 'Could not connect to the database server. Please check your network connection or server status.';
    } else {
        readableErrorMessage = 'An error occurred while saving the data. Please check the information provided and try again.';
    }

    return readableErrorMessage;
};
